import React from "react";
import { Pagination } from "react-bootstrap";

// Phones get fewer page numbers so the bar stays on one line.
const isNarrowScreen = () => window.matchMedia("(max-width: 768px)").matches;

function buildPageNumbers(current, total, delta = 2) {
  const pages = [];
  const left = Math.max(2, current - delta);
  const right = Math.min(total - 1, current + delta);

  pages.push(1);
  if (left > 2) pages.push("...");
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < total - 1) pages.push("...");
  if (total > 1) pages.push(total);

  return pages;
}

export default function PaginationBar({
  page,
  onPageChange,
  canPrev = true,
  canNext = true,
  showPageLabel = true,
  totalPages = null,
  totalItems = null
}) {
  const isFirst = !canPrev || page <= 1;
  const isLast = !canNext || (totalPages !== null && page >= totalPages);

  return (
    <div className="pagination-bar d-flex flex-wrap justify-content-between align-items-center gap-2 my-3">
      <Pagination size="sm" className="mb-0 flex-nowrap">
        <Pagination.First className="pagination-edge" onClick={() => onPageChange(1)} disabled={isFirst} />
        <Pagination.Prev onClick={() => onPageChange(page - 1)} disabled={isFirst} />
        {totalPages > 0
          ? buildPageNumbers(page, totalPages, isNarrowScreen() ? 1 : 2).map((p, idx) =>
              p === "..." ? (
                <Pagination.Ellipsis key={`ellipsis-${idx}`} disabled />
              ) : (
                <Pagination.Item
                  key={p}
                  active={p === page}
                  onClick={() => onPageChange(p)}
                >
                  {p}
                </Pagination.Item>
              )
            )
          : null}
        <Pagination.Next onClick={() => onPageChange(page + 1)} disabled={isLast} />
        <Pagination.Last
          className="pagination-edge"
          onClick={() => onPageChange(totalPages)}
          disabled={isLast || totalPages === null}
        />
      </Pagination>

      {(showPageLabel || totalItems !== null) && (
        <div className="text-muted small text-nowrap text-end">
          {showPageLabel && <>Page <b>{page}</b></>}
          {showPageLabel && totalItems !== null && " · "}
          {totalItems !== null && <>Total: <b>{totalItems}</b> items</>}
        </div>
      )}
    </div>
  );
}
